import styles from './TermsOfService.module.scss';
import {Link} from "react-router-dom";

export const TermsOfService = () => {
    return (
        <div className={styles['services-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['bottom-row']}>
                    <div className={styles['card5']}>
                        <div className={styles['title']}>
                            <p>Effective Date: November 1, 2024</p>
                            <p>Terms of Service</p>
                        </div>
                        <p>Welcome to Stamey-White Law (“we,” “our,” or “us”). By accessing or using our website or
                            services, you agree to comply with and be bound by these Terms of Service (“Terms”). Please
                            read them carefully. If you do not agree to these Terms, you may not use our website or
                            services.</p>
                        <div className={styles['frames-tos']}>
                            <p>1. Scope of Services</p>
                            <p>Stamey-White Law provides legal services in the areas of Alcoholic Beverage and Cannabis
                                Law. Use of our website or communications through it does not establish an
                                attorney-client relationship. Legal representation begins only after a signed engagement
                                agreement is executed.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>2. No Legal Advice</p>
                            <p>The content on our website, including articles, blogs, or any other material, is for
                                informational purposes only. It does not constitute legal advice. You should consult
                                directly with an attorney for advice tailored to your situation.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>3. User Responsibilities</p>
                            <p>When using our website or services, you agree to:</p>
                            <ul>
                                <li>Provide accurate, current, and complete information as requested.</li>
                                <li>Refrain from unlawful or prohibited uses, including transmitting harmful,
                                    defamatory, or offensive content.
                                </li>
                                <li>Respect our intellectual property rights and those of third parties.</li>
                            </ul>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>4. Intellectual Property</p>
                            <p>All content, materials, and information provided on our website, including logos, text,
                                graphics, and design, are the property of Stamey-White Law or its licensors. You may not
                                reproduce, distribute, modify, or create derivative works from our materials without
                                prior written consent.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>5. Privacy</p>
                            <p>Your use of our website and services is also governed by our <Link to="/privacy-policy">Privacy
                                Policy</Link> . By using our services, you consent to the collection and use of your
                                information as outlined in that policy.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>6. Disclaimers</p>
                            <ul>

                                <li>No Guarantee of Results: While we strive to provide excellent legal representation,
                                    we do not guarantee specific outcomes in any legal matter.
                                </li>
                                <li>Website Availability: We make reasonable efforts to keep our website functional and
                                    error-free but do not guarantee uninterrupted access or the absence of errors.
                                </li>
                                <li>Third-Party Links: Our website may contain links to third-party sites. We are not
                                    responsible for their content or practices and recommend reviewing their terms and
                                    policies.
                                </li>
                            </ul>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>7. Limitation of Liability</p>
                            <p>To the fullest extent permitted by law:</p>
                            <ul>
                                <li>Stamey-White Law is not liable for any indirect, incidental, or consequential
                                    damages
                                    arising from your use of our website or services.
                                </li>
                                <li>Our liability for direct damages is limited to the amount you paid for our
                                    services.
                                </li>
                            </ul>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>8. Indemnification</p>
                            <p>You agree to indemnify and hold Stamey-White Law, its attorneys, employees, and
                                affiliates harmless from any claims, liabilities, damages, or expenses arising out of
                                your use of our website, your violation of these Terms, or your infringement of any
                                third-party rights.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>9. Termination</p>
                            <p>We reserve the right to terminate or suspend your access to our website or services at
                                our sole discretion, without notice, if you violate these Terms or for any other
                                reason.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>10. Governing Law</p>
                            <p>These Terms and your use of our services are governed by the laws of the state of California, without regard to its conflict of law principles. Any disputes shall be resolved
                                in the courts of United States and California.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>11. Amendments</p>
                            <p>We may update these Terms periodically. Changes will be posted on this page with a
                                revised “Effective Date.” Your continued use of our website or services constitutes
                                acceptance of the updated Terms.</p>
                        </div>
                        <div className={styles['frames-tos']}>
                            <p>12. Contact Information</p>
                            <p>For questions or concerns about these Terms, please contact us:
                                Stamey-White, APC
                                2903 Noriega St 43 San Francisco, CA 94122
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}